import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { createAuthSlice, AuthState } from "./slices/auth";

export interface AppState extends AuthState {
  _hasHydrated: boolean;
}

const appState = (
  set: (fn: (state: AppState) => AppState) => void,
  get: () => AppState
) => ({
  _hasHydrated: false,
});

const useAppState = create<AppState & AuthState>()(
  devtools(
    persist(
      (set, get) => ({
        ...appState(set, get),
        ...createAuthSlice(set, get),
      } as any),
      {
        name: `cobrief.${import.meta.env.MODE}`,
        onRehydrateStorage: () => (state, error) => {
          if (state) {
            (state as AppState)._hasHydrated = true;
          }
        },
      }
    )
  )
);

export default useAppState;
